module.exports = __webpack_public_path__ + "img/image28.fdcf547c.png";